<div class="step-content">
    <div class="step-header">
        <h2>Work/Education history</h2>
        <div class="add-history-section" *ngIf="canAddMore()">
            <button type="button" class="btn btn-primary add-history-btn" (click)="addMoreHistory()" [disabled]="impersonatedUser">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                Add more history
            </button>
        </div>
    </div>

    <div class="work-history-list">
        <div class="table-container desktop-only" #tableWrapper>
            <app-table class="list-table location-table work-history-table" [data]="dataSource.data" 
            [columns]="tableColumns" id="tblAdmin" (clickEvent)="onTableClick($event)">
          </app-table>
      </div>
      
      @if(!dataSource.data.length){
        <div class="text-center no-data-msg">
            No records found
        </div>
        }
     <!-- Mobile Card View -->
     <div class="mobile-cards mobile-only" *ngIf="dataSource.data.length > 0">
        <div class="history-card" *ngFor="let item of dataSource.data">
            
            <div class="card-row">
                <span class="card-label">Work/school</span>
                <span class="card-value">{{ item.organizationName }}</span>
            </div>
            <div class="card-row">
                <span class="card-label">Start date</span>
                <span class="card-value">{{ item.startDate }}</span>
            </div>
            <div class="card-row">
                <span class="card-label">End date</span>
                <span class="card-value">{{ item.endDate }}</span>
            </div>
            <div class="card-row" *ngIf="!item.isLocationInDW">
                <span class="card-label">Action</span>
                <button class="btn-action" (click)="onTableClick({row:item,data:item.workHistoryId,otherParams:'edit'})">Edit</button>
            </div>
            <div class="card-row" *ngIf="!item.isLocationInDW&&!this.impersonatedUser">
                <span class="card-label"></span>
                <span class="card-value name-value" (click)="onTableClick({row:item,data:item.workHistoryId,otherParams:'delete'})">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="delete-icon" data-action="DELETE">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-1 14H6L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                        <path d="M9 6V4h6v2"></path>
                    </svg>
                </span>
            </div>
        </div>
    </div>

    <app-wizard-navigation class="history-navigation" (back)="onBack()" (next)="onNext()" (cancel)="onCancel()" [showNextOnly]="true" [disableNext]="false">
    </app-wizard-navigation>
</div>
</div>
